var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1168.000000pt",
    height: "803.000000pt",
    viewBox: "0 0 1168.000000 803.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,803.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4010 l0 -4010 5835 0 5835 0 0 4010 0 4010 -5835 0 -5835 0 0 -4010z m6895 931 c1248 -1746 1330 -1860 1346 -1844 9 10 607 846 1329 1858 722 1012 1317 1844 1321 1849 5 6 9 -1241 9 -2797 l0 -2807 -532 2 -533 3 -5 1131 -5 1131 -790 -1119 c-434 -616 -795 -1123 -801 -1128 -6 -6 -31 19 -69 73 -32 45 -391 554 -799 1132 l-741 1049 -3 -1137 -2 -1137 -520 0 c-286 1 -527 3 -535 6 -13 5 -15 336 -15 2806 0 1539 4 2797 8 2794 4 -3 606 -842 1337 -1865z m-1845 1606 c0 -2 -539 -962 -1198 -2133 -659 -1171 -1197 -2131 -1195 -2133 7 -9 75 -9 1221 -10 l1172 -1 -2 -532 -3 -533 -2134 -2 c-1697 -2 -2132 0 -2128 10 3 6 543 968 1200 2137 l1196 2125 -1199 3 -1200 2 0 535 0 535 2135 0 c1174 0 2135 -1 2135 -3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1ef1c73123ff1dc6fe318234b32abf6f.svg";
export { ForwardRef as ReactComponent };